module.exports = __webpack_public_path__ + "static/media/jakarta-selatan.003e3a38.svg";